import styled from '@emotion/styled/macro';

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Item = styled.li`
  a,
  button {
    cursor: pointer;
    display: block;
    width: 100%;
    padding: 12px 24px;
    border: 0;
    border-radius: 4px;
    font-family: 'FuturaStd';
    font-size: ${16 / 16}rem;
    font-weight: 700;
    color: var(--brand-black);
    text-decoration: none;
    transition: background-color 0.2s ease-in-out;
    background: transparent;
    text-align: left;
    &:hover,
    &.active {
      background: hsla(284, 57%, 97%, 1);
    }
    &.active {
      color: hsla(284, 52%, 30%, 1);
    }
    @media (min-width: 800px) {
      font-size: ${14 / 16}rem;
    }
  }
`;

export const Divider = styled.hr`
  margin: 24px 0;
  border: 0;
  display: block;
  width: 100%;
  opacity: 0.2;
  border-top: 0.5px solid var(--brand-black);
`;

export const MenuToggle = styled.button`
  position: absolute;
  top: 21px;
  right: 16px;
  height: 30px;
  border: 0;
  background-color: transparent;
  @media (min-width: 800px) {
    display: none;
  }
`;

export const Nav = styled.nav`
  &[data-active='false'] {
    margin-bottom: -40px;
    ${List} {
      display: none;
      @media (min-width: 800px) {
        display: block;
      }
    }
  }
  &[data-active='true'] {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    padding: 80px 30px;
    z-index: 1;
    background-color: var(--brand-white);
    @media (min-width: 800px) {
      position: static;
      width: auto;
      height: auto;
    }
  }
`;

export const Top = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;
